import gearIcon from "assets/images/icons/portal-order/gear.svg";
import PreviousPageButton from "components/PreviousPageButton";
// import OrderStep from 'layouts/OrderStep'
import MainLayouts from "layouts/MainLayouts";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";

const Summary = () => {
  const { orderProcess } = useSelector((state) => state.cart);

  return (
    <MainLayouts summary>
      <div className="container-lg-fluid px-0">
        <PreviousPageButton />
        {/* <div className="row justify-content-center d-lg-none d-block">
					<div className="col-12 col-md-12 col-lg-12 col-xl-8">
						<OrderStep />
					</div>
				</div> */}
      </div>
      <Modal
        size="sm_"
        show={orderProcess}
        aria-labelledby="example-modal-sizes-title-sm"
        centered
        backdrop="static"
        contentClassName="rounded-5 border-0"
      >
        <Modal.Body className="p-3">
          <div className="d-flex align-items-center justify-content-center gap-3">
            <img
              style={{ animation: "rotate-center 1.2s linear infinite" }}
              src={gearIcon}
              alt="gear.svg"
              width="70px"
              height="70px"
            />
            <div className="text-start">
              <p className="mb-0 fw-bold">Pesanan Sedang Diproses</p>
              <p className="mb-0">Mohon Tunggu</p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </MainLayouts>
  );
};
export default Summary;
